import { IDocumentIdentifier } from '@Common/Entities/BaseEntities';

export enum DocumentChangingKind {
    Add,
    Remove,
    Update,
    Reset,
    UpdateDescriptor
}

export interface IDocumentChangedParameters {
    changingKind: DocumentChangingKind;
    identifier: IDocumentIdentifier;
    document?: any;
}

export default class DocumentsTreeService {
    private callbacks = $.Callbacks();

    public fireDocumentChanged(changingKind: DocumentChangingKind, params: IDocumentIdentifier, document?: any): void;
    public fireDocumentChanged(params: IDocumentChangedParameters): void;
    public fireDocumentChanged(...args: any[]): void {
        if (args.length === 1) {
            this.callbacks.fire(args);
        }
        if (args.length >= 2) {
            this.callbacks.fire({
                changingKind: args[0],
                identifier: args[1],
                document: args[2]
            } as IDocumentChangedParameters);
        }
    }

    public onDocumentChanged(fn: (param: IDocumentChangedParameters) => void): void {
        this.callbacks.add(fn);
    }

    public offDocumentChanged(fn: (param: IDocumentChangedParameters) => void): void {
        this.callbacks.remove(fn);
    }

    public clear(): void {
        this.callbacks.empty();
    }
}
